import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/expense-types/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/expense-types/delete`,
        endpoint: `${endpointBackend}gci/expense-types/getall`
    }

    let list = {
        labelTitle: 'Lista de Tipos de Despesa',
        labelTitleButtonAdd: 'Incluir novo tipo de despesa',
        fieldsShowOnDelete: ['name'],
        columns: [
            {
                name: 'name',
                label: 'Nome',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
